import { AuthorizedGuard } from './core/guards/authorized/authorized.guard';
import { AutorizationGuard } from './core/guards/authorization/autorization.guard';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { RolesGuard } from './core/guards/roles/roles.guard';
import { CatalogGuard } from './core/guards/catalog/catalog.guard';
import { NgModule } from '@angular/core';
import { CustomPreloadingStrategy } from './core/services/customPreloadStrategy/custom-preload-strategy';
import { TechnicalWorksPageComponent } from './shared/components/technical-works-page/technical-works-page.component';
import { BreadcrumbsService } from 'src/app/core/services/breadcrumbs.service';
import {
  BaseRoutes,
  CommonRoutes,
  DocumentRoutes,
} from './core/model/enum/routes.enum';

const routes: Routes = [
  { path: '', redirectTo: BaseRoutes.Catalogues, pathMatch: 'full' },
  {
    path: `${BaseRoutes.Catalogues}`,
    canActivate: [CatalogGuard],
    loadChildren: () =>
      import('./catalogues/catalogues.module').then(m => m.CataloguesModule),
  },
  {
    path: `${BaseRoutes.CataloguesWithOpenBasket}`,
    canActivate: [CatalogGuard],
    loadChildren: () =>
      import('./catalogues/catalogues.module').then(m => m.CataloguesModule),
  },
  {
    path: `${BaseRoutes.MobileApp}`,
    canActivate: [CatalogGuard],
    loadChildren: () =>
      import('./catalogues/catalogues.module').then(m => m.CataloguesModule),
  },
  {
    path: `${BaseRoutes.MobileApp}/${BaseRoutes.CataloguesWithOpenBasket}`,
    canActivate: [CatalogGuard],
    loadChildren: () =>
      import('./catalogues/catalogues.module').then(m => m.CataloguesModule),
  },
  {
    path: `${CommonRoutes.Auth}`,
    canActivate: [AuthorizedGuard],
    loadChildren: () => import('./auth/auth.routes').then(m => m.authRoutes),
  },
  {
    path: `${CommonRoutes.ShortURL}/:id`,
    pathMatch: 'full',
    redirectTo: `${CommonRoutes.Auth}/${CommonRoutes.ShortURL}/:id`,
  },
  {
    path: BaseRoutes.SOFT_REGISTRATION,
    pathMatch: 'full',
    redirectTo: `${CommonRoutes.Auth}/${BaseRoutes.SOFT_REGISTRATION}`,
  },
  {
    path: `${BaseRoutes.StudentNew}/${CommonRoutes.Registration}/:registrationToken`,
    pathMatch: 'full',
    redirectTo: `${CommonRoutes.Auth}/${BaseRoutes.StudentNew}/${CommonRoutes.Registration}/:registrationToken`,
  },
  {
    path: `${CommonRoutes.ResetPassword}/:token`,
    pathMatch: 'full',
    redirectTo: `${CommonRoutes.Auth}/${CommonRoutes.ResetPassword}/:token`,
  },
  {
    path: BaseRoutes.StudentNew,
    canActivate: [AutorizationGuard, RolesGuard],
    providers: [BreadcrumbsService],
    data: {
      breadcrumb: 'MAIN_PAGE',
      iconPath: '/assets/svg/menu/home.svg',
    },
    loadChildren: () =>
      import('./student/student.module').then(m => m.StudentModule),
  },
  {
    path: `${BaseRoutes.Methodist}`,
    canActivate: [AutorizationGuard, RolesGuard],
    loadChildren: () =>
      import('./methodist/methodist.routes').then(m => m.methodistRoutes),
    data: {
      breadcrumb: 'MAIN_PAGE',
      iconPath: '/assets/svg/menu/home.svg',
    },
  },
  {
    path: `${BaseRoutes.CuratorNew}`,
    canActivate: [AutorizationGuard, RolesGuard],
    loadChildren: () =>
      import('./curator/curator.module').then(m => m.CuratorModule),
  },
  {
    path: `${BaseRoutes.Admin}`,
    canActivate: [AutorizationGuard, RolesGuard],
    loadChildren: () => import('./admin/admin.routes').then(m => m.adminRoutes),
  },
  {
    path: `${BaseRoutes.HeadTeacher}`,
    canActivate: [AutorizationGuard, RolesGuard],
    loadChildren: () =>
      import('./head-teacher/head-teacher.routes').then(
        m => m.headTeacherRoutes
      ),
    providers: [BreadcrumbsService],
  },
  {
    path: `${BaseRoutes.Manager}`,
    canActivate: [AutorizationGuard, RolesGuard],
    loadChildren: () =>
      import('./manager/manager.routes').then(m => m.managerRoutes),
  },
  {
    path: `${BaseRoutes.Announcements}`,
    loadChildren: () =>
      import('./shared/announcements/announcements.routes').then(
        m => m.announcementsRoutes
      ),
  },
  {
    path: DocumentRoutes.PublicOffer,
    data: {
      docName: DocumentRoutes.PublicOffer,
    },
    loadComponent: () =>
      import('./shared/docx/sample-doc/sample-doc.component').then(
        c => c.SampleDocComponent
      ),
  },
  {
    path: DocumentRoutes.PrivacyPolicy,
    data: {
      docName: DocumentRoutes.PrivacyPolicy,
    },
    loadComponent: () =>
      import('./shared/docx/sample-doc/sample-doc.component').then(
        c => c.SampleDocComponent
      ),
  },
  {
    path: BaseRoutes.LANDING,
    loadComponent: () =>
      import('./landing/landing.component').then(c => c.LandingComponent),
  },
  {
    path: 'system-error',
    component: TechnicalWorksPageComponent,
  },
  { path: '**', redirectTo: BaseRoutes.Catalogues, pathMatch: 'full' },
];

const routerOptions: ExtraOptions = {
  anchorScrolling: 'enabled',
  scrollPositionRestoration: 'enabled',
  preloadingStrategy: CustomPreloadingStrategy,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
  providers: [CustomPreloadingStrategy],
})
export class AppRoutingModule {}
